var styles = {"radioBoxWrapper":"VBG__DS__radio-box-module__3fXnu","showIndicator":"VBG__DS__radio-box-module__3K7Q3","checkmarkWrapper":"VBG__DS__radio-box-module__2ZElK","dark":"VBG__DS__radio-box-module__2Z58Q"};

export { styles as default };
